import React, { useState, useEffect } from 'react';
import { useSelector } from "react-redux";
import { Modal, Button, Card } from 'react-bootstrap'; // Importing necessary Bootstrap components
import { ModalQuiz } from '../../util/ui';

import authHeader from '../../services/auth-header';
import { config } from '../../config/client';
import { lowerFirst } from 'lodash';
// import { Document, Page as PDFPage } from '@react-pdf-viewer/core';
// import { Document, Page as PDFPage } from 'react-pdf';
// import 'react-pdf/dist/esm/entry.webpack'; // Ensure compatibility with Webpack
// import '@react-pdf-viewer/core/lib/styles/index.css';
import '../materials/index.css';
import Select from 'react-select';

const Page = () => {
  const { user: currentUser } = useSelector((state) => state.auth);

  const [assignments, setAssignments] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [selectedTopic, setSelectedTopic] = useState(null);
  const [topic, setTopic] = useState("");
  const [description, setDescription] = useState("");
  const [topicAssignments, setTopicAssignments] = useState({});
  const [pdfUrl, setPdfUrl] = useState(null); // State to hold PDF URL for in-browser viewing


  useEffect(() => {
    fetchDetails();
    if (!showModal) {
      setTopic("");
      setDescription("");
    }
  }, [showModal]);

  const fetchDetails = async () => {
    const response = await fetch(config.endpoint + "/get_assignments", {
      method: 'POST',
      body: JSON.stringify({ 'role': currentUser.role }),
      headers: authHeader()
    });
    const json = await response.json();
    // debugger;
    if (json.assignments) {
      const all_assignments = JSON.parse(json.assignments).filter(element => element != null);
      setAssignments(all_assignments);
      const groupedAssignments = all_assignments.reduce((acc, assignment) => {
        if (!acc[assignment.topic]) acc[assignment.topic] = [];
        acc[assignment.topic].push(assignment);
        return acc;
      }, {});
      setTopicAssignments(groupedAssignments);
    }
  };

  const topic_options = [
    { value: 'query', label: 'Query' },
    { value: 'data_cln', label: 'Data Cleaning' },
    { value: 'data_pro', label: 'Data Preprocessing' },
    { value: 'data_viz', label: 'Data Visualization' },
    { value: 'feat_eng', label: 'Feature Engineering' },
    { value: 'feat_sel', label: 'Feature Selection' },
    { value: 'analysis', label: 'Analysis' }
  ]

  const uploadAssignment = async e => {
    e.preventDefault();
    const form = document.forms.namedItem("uploadAssignmentForm");
    const data = new FormData(form);
    data.append("user", currentUser.username);
    data.append("isAssignment", true);
    data.append("topic", topic);
    data.append("description", description);

    await fetch(config.endpoint + "/uploadFile", {
      method: 'POST',
      body: data,
      headers: authHeader()
    });
    setShowModal(false);
    fetchDetails(); // Refresh the assignments list
  }

  const downloadAssignment = async (file_name) => {
    const response = await fetch(config.endpoint + "/download_assignments", {
      method: 'POST',
      body: JSON.stringify({ 'role': currentUser.role, 'file_name': file_name }),
      headers: {
        ...authHeader(),
        'Content-Type': 'application/json'
      }
    });
    if (response.ok) {
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.style.display = 'none';
      a.href = url;
      a.download = file_name;
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
    } else {
      console.error('Failed to download file:', response.statusText);
    }
  };

  const deleteAssignment = async (file_name) => {
    const confirmed = window.confirm("Are you sure you want to delete this assignment?");
    if (confirmed) {
      const response = await fetch(config.endpoint + "/delete_assignment", {
        method: 'POST',
        body: JSON.stringify({ 'file_name': file_name }),
        headers: {
          ...authHeader(),
          'Content-Type': 'application/json'
        }
      });
      if (response.ok) {
        setAssignments(assignments.filter(assignment => assignment.file_name !== file_name));
      } else {
        console.error('Failed to delete file:', response.statusText);
      }
    }
  };

  const handleTopicClick = (topic) => {
    setSelectedTopic(topic);
    setTopic(topic);
  };

  const handleBackClick = () => {
    setSelectedTopic(""); // Reset selected topic to show the topic list again
  };

  const viewAssignmentInBrowser = async (file_name) => {
    const response = await fetch(config.endpoint + "/download_assignments", {
      method: 'POST',
      body: JSON.stringify({ 'role': currentUser.role, 'file_name': file_name }),
      headers: {
        ...authHeader(),
        'Content-Type': 'application/json'
      }
    });
    if (response.ok) {
      const blob = await response.blob();
      const url = window.URL.createObjectURL(new Blob([blob], { type: 'application/pdf' }));
      window.open(url, '_blank'); // Open the PDF in a new tab
    } else {
      console.error('Failed to download file:', response.statusText);
    }
  };

  return (
    <div className='w-full my-4'>
      {!selectedTopic ? (
        <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'space-around', gap: '20px' }}>
          {topic_options.map(({ value, label }) => (
            <Card key={value} style={{ width: '300px', height: '150px', marginBottom: '20px', cursor: 'pointer' }} onClick={() => handleTopicClick(value)}>
              <Card.Body style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', textAlign: 'center' }}>
                <Card.Title style={{ color: 'blue', fontSize: '1.5em' }}>
                  {label}
                </Card.Title>
                <Card.Text style={{ fontSize: '1em' }}>
                  Number of Assignments: <span style={{ color: 'red' }}>{topicAssignments[value]?.length || 0}</span>
                </Card.Text>
              </Card.Body>
            </Card>
          ))}
        </div>
      ) : (
        <div>
          <Button onClick={handleBackClick} style={{ marginLeft: '20px', marginBottom: '20px' }} className="btn btn-secondary">
            Back to Topics
          </Button>

          {currentUser.role === 'Instructor' && (
            <>
              <Button onClick={() => setShowModal(true)}
                style={{ marginLeft: '20px', marginBottom: '20px', }}
                className="btn btn-primary mb-4">
                Upload Materials
              </Button>

              <ModalQuiz isOpen={showModal} setIsOpen={setShowModal} className="question-modal" clickBgToClose={false}>
                <div className="modal-header">
                  <h2>Upload Materials</h2>
                  <button type="button" className="close" onClick={() => setShowModal(false)}>
                    &times;
                  </button>
                </div>
                <div className="modal-body">
                  <form name="uploadAssignmentForm" onSubmit={uploadAssignment}>
                    <div className="form-group">
                      <label htmlFor="topic">Topic</label>
                      <Select options={topic_options}
                        id="topic"
                        placeholder="Select Topic ..."
                        required
                        value={topic_options.find(({ value }) => value === topic)}
                        onChange={(e) => setTopic(e.value)} />
                    </div>
                    <div className="form-group">
                      <label htmlFor="description">Description</label>
                      <textarea className="form-control" id="description" value={description} onChange={(e) => setDescription(e.target.value)} required></textarea>
                    </div>
                    <div className="form-group">
                      <label htmlFor="file">File</label>
                      <input type="file" className="form-control" id="file" name="file" required />
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'center', gap: '10px', marginTop: '20px' }}>
                      <button type="submit" className="btn btn-primary mt-2">Submit</button>
                      <button
                        onClick={() => setShowModal(false)}
                        className="btn btn-danger mt-2"
                        type="button">
                        Cancel
                      </button>
                    </div>
                  </form>
                </div>
              </ModalQuiz>
            </>
          )}

          <div>
            {topicAssignments[selectedTopic] && topicAssignments[selectedTopic].map((assignment, index) => (
              <Card key={index} style={{ margin: '20px' }}>
                <Card.Body>
                  <Card.Title>
                    {assignment.file_name}
                    {currentUser.role === 'Instructor' && (
                      <Button style={{ float: 'right', marginLeft: '10px' }} onClick={() => deleteAssignment(assignment.file_name)} className="btn btn-danger">
                        Delete
                      </Button>
                    )}
                    <Button
                      style={{ float: 'right', marginLeft: '10px' }}
                      onClick={() => viewAssignmentInBrowser(assignment.file_name)} className="btn btn-secondary">
                      View
                    </Button>
                    <Button
                      style={{ float: 'right', marginLeft: '10px' }}
                      onClick={() => downloadAssignment(assignment.file_name)} className="btn btn-secondary">
                      Download
                    </Button>
                  </Card.Title>
                  <Card.Text>{assignment.desc}</Card.Text>
                </Card.Body>
              </Card>

              // View file within browser here:
            ))}
            {/* {pdfUrl && (
              <Modal show={!!pdfUrl} onHide={() => setPdfUrl(null)} size="lg">
                <Modal.Header closeButton>
                  <Modal.Title>View PDF</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <Document file={pdfUrl}>
                    <PDFPage pageNumber={1} />
                  </Document>
                </Modal.Body>
              </Modal>
            )} */}
            {/* {pdfUrl && (
              <Modal show={!!pdfUrl} onHide={() => setPdfUrl(null)} size="lg">
                <Modal.Header closeButton>
                  <Modal.Title>View PDF</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <Document file={pdfUrl}>
                    <Page pageNumber={1} />
                  </Document>
                </Modal.Body>
              </Modal>
            )} */}
          </div>
        </div>
      )}
    </div>
  );
};

export default Page;